export default {
  fi: {
    ServiceEventCreateScene: {
      addServiceEvent: 'Lisää huolto',
      attachmentsAfterCreateInfo:
        'Voit lisätä huoltotapahtumalle liitetiedostoja tallentamisen jälkeen.',
      addAttachmentsPromptTitle: 'Tiedot tallennettu. Haluatko lisätä liitetiedostoja huoltotapahtumaan?',
      addAttachmentsPromptYes: 'Kyllä',
      addAttachmentsPromptNo: 'Ei',
    },
  },
};
